import React, { useState, useEffect } from 'react';
import { useTheme } from '../../../../context/ThemeContext';
import { apiGet } from '../../../../utils/api';
import { Zap } from 'lucide-react';

const ClientFeaturesPanel = ({ clientId }) => {
    const { theme } = useTheme();
    const dark = theme === 'dark';
    const [features, setFeatures] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => { fetchFeatures(); }, [clientId]);

    const fetchFeatures = async () => {
        try {
            const res = await apiGet(`/client_manager/features${clientId ? `?client_id=${clientId}` : ''}`);
            if (res.ok) {
                const data = await res.json();
                setFeatures(data.features);
            }
        } catch {} finally { setLoading(false); }
    };

    const categoryColors = {
        general: dark ? 'bg-blue-900/30 text-blue-400' : 'bg-blue-50 text-blue-700',
        tools: dark ? 'bg-purple-900/30 text-purple-400' : 'bg-purple-50 text-purple-700',
        analytics: dark ? 'bg-green-900/30 text-green-400' : 'bg-green-50 text-green-700',
        communication: dark ? 'bg-orange-900/30 text-orange-400' : 'bg-orange-50 text-orange-700',
    };

    if (loading) return <div className="text-center py-8 text-gray-500 font-rasa">Loading...</div>;

    return (
        <div className="space-y-4">
            <div>
                <h2 className="text-lg font-dm-serif">Available Features</h2>
                <p className="text-sm text-gray-500 font-rasa mt-1">Features enabled for your organization by the system administrator</p>
            </div>

            {features.length === 0 ? (
                <div className={`text-center py-8 rounded-lg ${dark ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'} border`}>
                    <Zap className="w-12 h-12 mx-auto mb-3 text-gray-400" />
                    <p className="text-gray-500 font-rasa">No features enabled yet</p>
                    <p className="text-sm text-gray-400 font-rasa mt-1">Contact your administrator to enable features</p>
                </div>
            ) : (
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
                    {features.map(f => (
                        <div key={f.id} className={`p-4 rounded-lg border ${dark ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'}`}>
                            <div className="flex items-center gap-2 mb-2">
                                <Zap size={16} className={dark ? 'text-blue-400' : 'text-blue-600'} />
                                <span className="font-dm-serif text-sm">{f.name}</span>
                            </div>
                            <p className="text-xs text-gray-500 font-rasa mb-2">{f.description}</p>
                            <span className={`px-2 py-0.5 rounded text-xs font-rasa ${categoryColors[f.category] || ''}`}>
                                {f.category}
                            </span>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default ClientFeaturesPanel;
